<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Relatório</span>
        <h3 class="page-title d-inline">Segmento</h3>
      </div>
    </div>

    <div class="card mb-4">
      <form @submit.prevent="getList" class="w-100">
        <d-row class="align-items-center px-3">
          <d-col cols="3" class="form-group mt-2">
            <label>Usuários</label>
            <select-seller :defaul-option="true" label="Todos os usuários" :model.sync="filters.userId"></select-seller>
          </d-col>
          <d-col cols="2" class="form-group mb-0">
            <label class="submit">&nbsp;</label>
            <d-button class="btn mt-3" type="submit">Filtrar</d-button>
          </d-col>
        </d-row>
      </form>
    </div>

    <!-- Default Light Table -->
    <d-row >
      <d-col>
        <div class="card card-small mb-4">
          <div class="card-header"></div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <table class="table mb-0 table-striped">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Segmento</th>
                    <th scope="col" class="border-0">Meta Semanal</th>
                    <th scope="col" class="border-0">Meta Mensal</th>
                    <th scope="col" class="border-0">Meta Anual</th>
                    <th scope="col" class="border-0">Orçado</th>
                    <th scope="col" class="border-0">Fechado</th>
                    <th scope="col" class="border-0">Balanço semanal</th>
                    <th scope="col" class="border-0">Balanço mensal</th>
                    <th scope="col" class="border-0">Balanço anual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in reports.list" :key="index" class="align-items-center">
                    <td class="td-1">{{ row.drive }}</td>
                    <td class="td-1">{{ addCurrencyMask(row.goal_weekly) }}</td>
                    <td class="td-1">{{ addCurrencyMask(row.goal_monthly) }}</td>
                    <td class="td-1">{{ addCurrencyMask(row.goal_yearly) }}</td>
                    <td class="td-1">{{ addCurrencyMask(row.quotations) }}</td>
                    <td class="td-1">{{ addCurrencyMask(row.approved) }}</td>
                    <td :class="['td-1', (row.balance_weekly > 0) ? 'text-success' : 'text-danger' ]">{{ addCurrencyMask(row.balance_weekly) }}</td>
                    <td :class="['td-1', (row.balance_monthly > 0) ? 'text-success' : 'text-danger' ]">{{ addCurrencyMask(row.balance_monthly) }}</td>
                    <td :class="['td-1', (row.balance_yearly > 0) ? 'text-success' : 'text-danger' ]">{{ addCurrencyMask(row.balance_yearly) }}</td>
                  </tr>
                  <tr v-if="reports.list.length === 0">
                    <td colspan="9" class="no-content">Ainda não tem nenhum resultado.</td>
                  </tr>
                </tbody>
                <!-- <import-modals/> -->
              </table>
            </div>
          </div>
        </div>
        <report-total :totals="reports.total"></report-total>
      </d-col>
    </d-row>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CurrencyMask from '_common/mixins/CurrencyMask';
import Pagination from '_shared/Pagination.vue';
import ReportService from '_services/rest/modules/report';
import SelectSeller from '_shared/SelectSeller.vue';
import ReportTotal from '../components/ReportTotal.vue';
import ReportProductTable from '../components/ReportProductTable.vue';

export default {
  name: 'report-drive-list',
  mixins: [CurrencyMask],
  components: {
    Pagination,
    SelectSeller,
    ReportTotal,
    ReportProductTable,
  },
  data() {
    return {
      filters: { userId: '' },
      reports: {
        list: [],
        total: {},
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
    ]),
    getList() {
      ReportService.getReportDrivesList(this.filters)
        .then(response => {
          this.reports = response;
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  min-height: 20vh;
}
</style>
